/******************************************************************
 * Copyright @ 2023 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   src\routes\PC\Login\index.tsx
 * @author Gim
 * @date   2023/01/12 13:58
 * @desc   此页面用于为其他域名的网页提供SSO登录。
 *          其他域名的页面使用iframe嵌套用户中心的访问此页面。
 *          这些规则与逻辑将使用sso_plugin封装起来，方便其他域名页面直接使用。
 *
 *          这是个完整的网页
 ******************************************************************/
import imgLoginBg from '@/assets/images/login_bg2@2x.png';
import { i18n } from '@/i18n';
import { LoginView } from '@routes/Login';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useSSOLogic } from '../useSSOLogic';
import styles from './index.module.less';
export default function LoginPage() {
    var _a;
    const { t } = i18n;
    const { from, signal, title, ICP, copyright, formVisible } = useSSOLogic();
    const [inited, setInited] = useState(false);
    useEffect(() => {
        const tid = setTimeout(() => setInited(true), 1);
        return () => clearTimeout(tid);
    }, []);
    if (typeof from !== 'string')
        return React.createElement(React.Fragment, null, "\u4F60\u9700\u8981\u8F6C\u9012from\u53C2\u6570\uFF0C\u8FD9\u4E2Afrom\u53C2\u6570\u5C31\u662F\u4F60\u7684\u57DF\u540D");
    if (typeof signal !== 'string')
        return React.createElement(React.Fragment, null, "\u4F60\u9700\u8981\u8F6C\u9012signal\u53C2\u6570\uFF0C\u8FD9\u4E2Asignal\u53C2\u6570\u5C31\u662F\u901A\u8BAF\u7684\u6697\u53F7\uFF0C\u5EFA\u8BAE\u968F\u673A\u751F\u6210\u3002");
    const _copyright = useMemo(() => {
        return copyright !== null && copyright !== void 0 ? copyright : t('copyright_notice').replace('%1', '' + new Date().getFullYear());
    }, [copyright]);
    return (React.createElement("div", { className: styles.login_page_root },
        React.createElement("div", { className: styles.header_zone }, title ?
            React.createElement("div", { className: styles.txt_title }, title) :
            React.createElement("img", { className: styles.img_header, src: imgLoginBg, alt: '' })),
        React.createElement(LoginView, { className: classNames(styles.login_wrap, { [styles.login_wrap_hidden]: !inited || !formVisible }) }),
        React.createElement("div", { className: styles.bottom_zone },
            React.createElement("div", { className: styles.memo },
                _copyright,
                !ICP ? null : React.createElement("a", { className: styles.icp, href: (_a = ICP === null || ICP === void 0 ? void 0 : ICP.url) !== null && _a !== void 0 ? _a : 'https://beian.miit.gov.cn/' }, ICP.code)))));
}
